export default __webpack_public_path__ + "media/titles/title_2_locale_tr-b1b9e0c7.png";